
  import {Component, Vue} from 'vue-property-decorator';
  import {ICarList} from "@/modules/CarList/interfaces/car-list.interface";
  import {bus} from "@/plugins/bus";

  @Component({})
  export default class CarListEmpty extends Vue {
    get filterEmpty() { return !this.$store.getters['carList/mainFilterEmpty']; }

    clearFilters() {
      bus.$emit(ICarList.EmitterEvents.CLEAR_FILTERS);
    }
  }
